export enum InvoiceType {
  user = "user",
  partner = "partner",
}
